<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <!-- Modal close -->
  <div
    class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default"
    v-show="approvalModal"
    @click="(approvalModal = false)"
  ></div>

  <div class="shadow overflow-hidden w-full max-w-4xl">
    <div>
      <dl>
        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontractfile.name") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontractfile.name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontractfile.file") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            <p class="cursor-pointer text-blue-600 underline" @click="download(employeecontractfile.file, '/download-employee-contract-file', employeecontractfile.id)" :title="employeecontractfile.file">
              {{ employeecontractfile.file }}
            </p>
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontractfile.created_by") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontractfile.created_by }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontractfile.updated_by") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontractfile.updated_by }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontractfile.created_at") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontractfile.created_at }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontractfile.updated_at") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontractfile.updated_at }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'
import axios from 'axios'
import { axiosDocument } from '@/boot/axios'
import { useToast } from 'vue-toastification'

export default {
  name: "EmployeeContractFileDetail",
  components: {},
  props: {
    propEmployeeContractFile: {
      type: Object,
      default: () => ({  empty: true }),
    },
  },
  emits: ['close-modal', 'submit'],
  setup(props, { emit }) {
    const toast = useToast()
    const titleStack = ref(['Admin', 'Details'])

    const employeecontractfile = reactive({
      id: "",
      employee_id: "",
      contract_type_id: "",
      name: "",
      file: "",
      created_by: "",
      updated_by: "",
      created_at: "",
      updated_at: "",
    })

    const download = (name, url, id) => {
      const params = { filename: name, id }

      axios
        .get(url, { params, responseType: 'blob' })
        .then((response) => {
          triggerDownload(response.data, name)
        })
        .catch((error) => {
          console.error('Primary download failed:', error)
          // toast.error('Download failed: ' + (error.response?.data?.message || error.message))

          // Fallback
          downloadDoc(name, id)
        })
    }

    const downloadDoc = (name, id) => {
      const params = { filename: name, id }

      axiosDocument
        .get('/download-employee-contract-file', { params, responseType: 'blob' })
        .then((response) => {
          triggerDownload(response.data, name)
        })
        .catch((error) => {
          console.error('Fallback download failed:', error)
          toast.error('Fallback failed: ' + (error.response?.data?.message || error.message))
        })
    }

    const triggerDownload = (blobData, filename) => {
        const fileURL = window.URL.createObjectURL(new Blob([blobData]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', filename)
        document.body.appendChild(fileLink)
        fileLink.click()
        document.body.removeChild(fileLink)
        window.URL.revokeObjectURL(fileURL)
    }

    watchEffect(() => {
      if (
        props.propEmployeeContractFile &&
        Object.keys(props.propEmployeeContractFile).length > 0 &&
        !props.propEmployeeContractFile.empty
      ) {
        Object.assign(employeecontractfile, props.propEmployeeContractFile)
      }
    })


    return {
      titleStack,
      employeecontractfile,
      download,
      downloadDoc
    }
  },
}
</script>
